import { motion } from "framer-motion";
import LeadForm from "@/components/LeadForm";

const HEADLINE_LINES = [
  { text: "Your account could be", accent: false },
  { text: "at risk right now —", accent: true },
  { text: "and you probably", accent: false },
  { text: "don’t know it.", accent: false },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <main
      data-testid="hero-section"
      className="relative z-10 mx-auto flex min-h-screen w-full max-w-4xl flex-col items-center justify-center gap-10 px-6 pb-16 pt-24 text-center md:gap-14"
    >
      <h1
        data-testid="hero-headline"
        className="font-display text-[clamp(1.9rem,7.2vw,4.25rem)] font-bold uppercase leading-[1.06] tracking-tight"
      >
        {HEADLINE_LINES.map((line, i) => (
          <span key={line.text} className="block overflow-hidden pb-[0.08em]">
            <motion.span
              className="relative inline-block whitespace-nowrap"
              initial={{ y: "115%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: 0.15 + i * 0.12, ease: EASE }}
            >
              {line.accent ? (
                <span className="relative inline-block">
                  {line.text}
                  <motion.svg
                    aria-hidden="true"
                    viewBox="0 0 300 14"
                    preserveAspectRatio="none"
                    className="absolute -bottom-[0.12em] left-0 h-[0.16em] w-full"
                  >
                    <motion.path
                      d="M4 9 C 60 3, 120 12, 180 7 S 280 4, 296 8"
                      fill="none"
                      stroke="#1A1F5E"
                      strokeWidth="5"
                      strokeLinecap="round"
                      initial={{ pathLength: 0 }}
                      animate={{ pathLength: 1 }}
                      transition={{ duration: 0.9, delay: 1.0, ease: "easeOut" }}
                    />
                  </motion.svg>
                </span>
              ) : (
                line.text
              )}
            </motion.span>
          </span>
        ))}
      </h1>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
        className="flex w-full flex-col items-center gap-4"
      >
        <LeadForm />
        <p
          data-testid="trust-line"
          className="text-xs uppercase tracking-[0.2em] text-[#4A4D7A]/70"
        >
          Used by 200+ creators across Scandinavia.
        </p>
      </motion.div>
    </main>
  );
}
